<script lang="ts" setup>
defineProps({
    isSolid: {
        type: Boolean,
        default: false
    }
})
</script>

<template>
    <svg
        v-if="isSolid"
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="m11.5686 14.0662-3.18746-3.4777c-.3045-.333-.045-.8385.432-.8385h6.37346c.477 0 .7373.5055.432.8385l-3.1867 3.4777c-.2243.2453-.639.2453-.8633 0Z"
            clip-rule="evenodd"
        />
    </svg>

    <svg
        v-else
        xmlns="http://www.w3.org/2000/svg"
        class="fill-current"
        viewBox="0 0 24 24"
    >
        <path
            fill-rule="evenodd"
            d="m11.5686 14.0662-3.18746-3.4777c-.3045-.333-.045-.8385.432-.8385h6.37346c.477 0 .7373.5055.432.8385l-3.1867 3.4777c-.2243.2453-.639.2453-.8633 0Z"
            clip-rule="evenodd"
        />
    </svg>
</template>
